import { FC } from 'react';
import { useRouter } from 'next/router';
import { analytics } from '@shared/utils/segment.utils';
import MainMenuLogo from './MenuLogo';
const MainMenuLogoLogic: FC = () => {
  const router = useRouter();
  const onClickLogo = () => {
    analytics.track('Logo Click', {
      event: 'Logo Click'
    });
    router.push('/');
  };
  return <MainMenuLogo onClick={onClickLogo} />;
};
export default MainMenuLogoLogic;